<template>
  <div>
    <div class="preview-video-container-wrapper">
      <div ref="videoContainer" class="preview-video-container">
        <div ref="circleContainer" class="preview-circle-container">
        </div>
      </div>
      <div class="preview-circle-container-label">
        Hey, you look great!
      </div>
    </div>
    <div class="audio-level-graph">
      <div class="audio-level-graph-title">
        Mic level
      </div>
      <div
        v-for="index in Array.from(Array(10).keys())"
        :key="index"
        :class="[{ lit: audioLevel > index }, 'audio-level-item']"
      >
      </div>
    </div>
  </div>
</template>

<script>
const { createLocalTracks } = require('twilio-video');
const { pollAudioLevel } = require('@/twilio/pollaudiolevel');

export default {
  name: 'VideoAndAudioPreview',
  components: {
  },
  props: {
    redirectedFromCorrectPage: Boolean
  },
  data: () => ({
    localTracks: [],
    audioLevel: 0,
  }),
  computed: {
    localTracksAreLoaded: function () {
      return this.localTracks.length > 0;
    }
  },
  methods: {
    attachTrack(track) {
      const mediaElement = track.attach();
      mediaElement.muted = true;
      mediaElement.autoplay = true;
      this.$refs.circleContainer.appendChild(mediaElement);
    },
    resizeToSquare() {
      // console.log('here');
      const circleDiameter = Math.min(this.$refs.videoContainer.clientWidth, this.$refs.videoContainer.clientHeight);
      this.$refs.circleContainer.style.height = circleDiameter + 'px';
      this.$refs.circleContainer.style.width = circleDiameter + 'px';
    },
    startAudioLevelPolling() {
      for (let i = 0; i < this.localTracks.length; ++i) {
        const track = this.localTracks[i];
        if (track.kind === 'audio') {
          pollAudioLevel(track, level => {
            this.audioLevel = level;
          });
          break;
        }
      }
    },
    async getAndAttachLocalTracks() {
      this.$emit('display-connect-video-modal', false);
      try {
        this.localTracks = await createLocalTracks({
          audio: true,
          video: { height: 480, width: 480, frameRate: 24 }
        });
        this.localTracks.forEach(track => this.attachTrack(track));
        this.$emit('load-local-tracks', this.localTracks);
      } catch (error) {
        console.log('Error:', error);
        this.$emit('display-connect-video-modal', true);
      }
    },
  },
  mounted: function() {
    this.$nextTick(async function() {
      if (this.redirectedFromCorrectPage) {
        this.resizeToSquare();
        window.addEventListener('resize', this.resizeToSquare);
        if (process.env.VUE_APP_ENABLE_VIDEO === 'true') {
          await this.getAndAttachLocalTracks();
        }
        this.startAudioLevelPolling();
      }
    });
  },
  beforeDestroy: function() {
    if (this.redirectedFromCorrectPage) {
      window.removeEventListener('resize', this.resizeToSquare);
    }
  }
}
</script>

<!-- don't use scoped here otherwise the video styles won't get applied properly -->
<style lang="scss">
.preview-video-container-wrapper {
  display: flex;
  position: absolute;
  top: 5%;
  left: 10%;
  bottom: 5%;
  right: 40%;
}

.preview-video-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 10%;
  right: 0;
}

.preview-circle-container-label {
  position: absolute;
  top: 90%;
  left: 0;
  bottom: 0;
  right: 0;
  font-size: 0.8em;
  font-style: italic;
  padding-top: 0.6em;
}

.audio-level-graph {
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-start;
  position: absolute;
  top: 15%;
  left: 65%;
  bottom: 5%;
  right: 15%;
}

.audio-level-graph-title {
  flex: 0;
  padding-top: 0.6em;
  min-height: max-content;
}

.audio-level-item {
  flex: 1;
  height: 3%;
  width: 30%;
  border-radius: 0.4em;
  margin: 0.2em auto;
  background-color: $light-gray;
  &.lit {
    background-color: $parakeet-green;
  }
}

.preview-circle-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: black;
  border: 6px solid $brand-teal;
  border-radius: 50%;
  overflow: hidden;
  
}
.preview-circle-container > video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scaleX(-1);
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
</style>